import apiClient from './api-client';

export const apiFetchResults = async (user, id, lastKey = null) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/barankov', {
        user: user,
        exercise: id,
        lastKey: lastKey
    });
    return response
}
export const apiFetchExercises = async (user) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/kutukov', {
        user: user
    });
    return response
}

export const apiAddNewResult = async (user, result) => {
    await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/gusev', {
        user: user,
        result: result
    });
}
export const apiAddNewExercise = async (user, exercise) => {
    await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/hvatov', {
        user: user,
        exercise: exercise
    });
}

export const apiUpdateResult = async (user, result) => {
    await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/leshinin', {
        user: user,
        result: result
    });
}

export const apiUpdateExercise = async (user, exercise) => {
    await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/politsin', {
        user: user,
        exercise: exercise
    });
}

export const apiBatchUpdateExercises = async (user, exercises) => {
    await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/zukov', {
        user: user,
        exercises: exercises
    });
}


export const apiDeleteExercise = async (user, exercise) => {
    await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/rudykh', {
        user: user,
        exercise: exercise
    });
}

export const apiDeleteResults = async (user, results) => {
    await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/tkachev', {
        user: user,
        results: results
    });
}

export const apiFetchCatalog = async (language, group) => {

    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/denisov', {
        language: language,
        group: group
    });


    return response

}

export const apiSwapExercises = async (user, current, another) => {
    await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/zotov', {
        user: user,
        current: current,
        another: another
    });
}

export const apiGetTimeline = async (user, lastSync) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/nuhlova', {
        user: user,
        lastSync: lastSync
    })

    return response
}

export const apiGetPosts = async (posts) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/sorokina', {
        posts: posts
    })

    return response
}

export const apiGetComments = async (postId, lastKey) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/bandurko', {
        postId: postId,
        lastKey: lastKey
    })
    return response
}

export const apiGetPostsByUser = async (user) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/pokidko', {
        user: user,
    })
    return response
}

export const apiPublishPost = async (post) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/zolotarev', {
        post: post,
    })
    return response
}
export const apiPublishComment = async (comment) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/toropov', {
        comment: comment,
    })
    return response
}

export const apiLikePost = async (postId, like, userId, userName) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/shadrikova', {
        postId: postId,
        like: like,
        userId: userId,
        userName: userName
    })
    return response
}

export const apiGetLikesByPost = async (postId) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/eskov', {
        postId: postId
    })
    return response
}


export const apiSyncComments = async (items, user) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/talipov', {
        items: items,
        user: user,
        freshItemsNeeded: false,
        time: Date.now()
    })
    return response
}

export const apiSyncPosts = async (items, user) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/cheremiskin', {
        items: items,
        user: user,
        freshItemsNeeded: false,
        time: Date.now()
    })
    return response
}

export const apiUploadAvatar = async (user, image) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/shapovalov', {
        user: user,
        image: image,
        time: Date.now()
    })
    return response
}

export const apiGetAllBuddiesByUser = async (user) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/lameko', {
        user: user,
        time: Date.now()
    })
    return response
}

export const apiSearchBuddy = async (searchTerm) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/babusenko', {
        term: searchTerm,
        time: Date.now()
    })
    return response
}

export const apiFollowBuddy = async (user, buddyId, buddyName, buddyEmail, follow) => {
    const response = await apiClient.post('https://0hu4s9y08a.execute-api.eu-central-1.amazonaws.com/vedenin', {
        user: user,             //required
        buddyId: buddyId,       //required
        buddyName: buddyName,
        buddyEmail: buddyEmail,
        follow: follow,         //required
        time: Date.now()
    })
    return response
}

